export default __webpack_public_path__ + "static/media/Poppins-Thin.7a48b1c8.woff";